export default __webpack_public_path__ + "static/media/smart-lighting-system.0109aa81.jpeg";